export default {
  namespaced: true,
  digital_signature: {
    title: "Firma digital",
    file_video: "Archivo de video",
    file_signature: "Archivo firma",
  },
};
